import React from 'react';
import styles from './index.module.scss';
import Skeleton from 'react-loading-skeleton';

// 左侧导航栏骨架屏
const SkeletonSidebar = () => {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.skeletonItem}>
        <Skeleton circle width={28} height={28} />
        <Skeleton width={162} height={24} className={styles.skeletonNavLine} />
      </div>
      <div className={styles.skeletonItem}>
        <Skeleton circle width={28} height={28} />
        <Skeleton width={162} height={24} className={styles.skeletonNavLine} />
      </div>
      <div className={styles.skeletonItem}>
        <Skeleton circle width={28} height={28} />
        <Skeleton width={162} height={24} className={styles.skeletonNavLine} />
      </div>
      <div className={styles.skeletonItem}>
        <Skeleton circle width={28} height={28} />
        <Skeleton width={162} height={24} className={styles.skeletonNavLine} />
      </div>
      <div className={styles.homeSideBtn}>
        <Skeleton width={224} height={44} className={styles.skeletonHomeSideBtn} />
        <Skeleton width={224} height={44} className={styles.skeletonHomeSideBtn} />
      </div>
      <div className={styles.skeletonFooter}>
        <div className={styles.skeletonFooterContent}>
          <Skeleton circle width={28} height={28} />
          <Skeleton width={162} height={24} className={styles.skeletonNavLine} />
        </div>
      </div>
    </aside>
  );
};

export default SkeletonSidebar;
